import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'al-ratings',
  templateUrl: './al-ratings.component.html',
  styleUrls: ['./al-ratings.component.css']
})
export class AlRatingsComponent implements OnInit {
  // Initial value for rating set to 0 and will update as per the value provided by its selector from its parent component.
  @Input() rating = 0;
  starRating;

  constructor() { }

  ngOnInit() {
    this.starRating = this.rating * 20 + '%';
  }
}
